// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServicePrices_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /so/additional_service_prices/salvar
 * (controllers/so/additional_service_prices.php::salvar).
 *
 * Cria ou atualiza a linha de preco de UM adicional para UMA franquia.
 *
 * Campos:
 *   - so_additional_service_price_additional_id (int, OBRIGATORIO)
 *   - so_additional_service_price_price         (int, OBRIGATORIO — CENTAVOS,
 *     como a irma ServicePriorities_SalvarInput)
 *   - so_additional_service_price_id            (int, opcional — presente = update)
 *   - so_additional_service_price_franchise_id  (int, opcional no update;
 *     exigido na criacao pelo controller)
 *   - so_additional_service_price_deadline_days (int, opcional)
 *   - so_additional_service_price_active        (int 0|1, opcional — 0 é
 *     "esta franquia desligou o adicional", nunca lixo)
 */
import { registerContract } from './validate'

export interface AdditionalServicePrices_SalvarInput {
so_additional_service_price_additional_id: number
so_additional_service_price_price: number
so_additional_service_price_id?: number
so_additional_service_price_franchise_id?: number
so_additional_service_price_deadline_days?: number
so_additional_service_price_active?: number
}

registerContract('AdditionalServicePrices_SalvarInput', {
  so_additional_service_price_additional_id: { type: 'number',  required: true },
  so_additional_service_price_price:         { type: 'number',  required: true },
  so_additional_service_price_id:            { type: 'number',  required: false },
  so_additional_service_price_franchise_id:  { type: 'number',  required: false },
  so_additional_service_price_deadline_days: { type: 'number',  required: false },
  so_additional_service_price_active:        { type: 'number',  required: false },
})
